export default __webpack_public_path__ + "static/media/doctor-icon.4fac29b4.svg";